import { FC } from 'react';
import '../ArticleComponent.scss';
import './Article7.scss';
import { Section1, Links } from './article7_model';

const Article7Component: FC = () => {
	return (
		<div className='page'>
			<div className='section--intro seven-first'>
				<div className='section-container '>
					<h3 className='section-heading'>{Section1.heading}</h3>
					<p className='info-600'>
						<span>{Section1.para1.content1}</span>
						<a href={Links.nbj_summit} className='info-600' target='_blank' rel='noopener'>
							{Section1.para1.content2_link}
						</a>
						<span>{Section1.para1.content3}</span>
						<a href={Links.how_good} className='info-600' target='_blank' rel='noopener'>
							{Section1.para1.content4_link}
						</a>
						<span>{Section1.para1.content5}</span>
						<a href={Links.carbon_footprint} className='info-600' target='_blank' rel='noopener'>
							{Section1.para1.content6_link}
						</a>
						<span>{Section1.para1.content7}</span>
					</p>
					<p className='info-400'>{Section1.para2}</p> <br></br>
					<br></br>
					<p className='info-400'>{Section1.para3}</p>
					<br></br>
					<br></br>
					<p className='info-400'>
						<span>{Section1.para4.content1}</span>
						<a href={Links.beacon_discovery} target='_blank' rel='noopener'>
							{Section1.para4.content2_link}
						</a>
						<span>{Section1.para4.content3}</span>
					</p>
				</div>
			</div>
		</div>
	);
};

export default Article7Component;
